module.exports = __webpack_public_path__ + "img/logo-cfs.c13ebf4d.png";